import { fetcher as fetcherUtil } from '@repo/utils';
import type { FetcherOptions } from '@repo/utils';

export const fetcher = async (
    input: RequestInfo | URL,
    init?: RequestInit,
    options?: FetcherOptions
): Promise<Response> => {
    return fetcherUtil(input, init, options);
};
